const config = {
  MAX_ATTACHMENT_SIZE: 60 * 1000000, // number * 1MB
  FORMS_BUCKET: "vicus-proposal-forms",
  s3: {
    REGION: "us-east-2",
    BUCKET: "vicus-proposal-forms",
  },
  apiUserGateway: {
    REGION: "us-east-2",
    URL:
      process.env.NODE_ENV === "production"
        ? "https://y1caj3ubi6.execute-api.us-east-2.amazonaws.com/prod"
        : "https://y1caj3ubi6.execute-api.us-east-2.amazonaws.com/dev",
    FILELIMIT: 4194304,
  },
  apiComplianceGateway: {
    REGION: "us-east-2",
    URL:
      process.env.NODE_ENV === "production"
        ? "https://r4ei85yvpb.execute-api.us-east-2.amazonaws.com/prod"
        : "https://r4ei85yvpb.execute-api.us-east-2.amazonaws.com/dev",
    FILELIMIT: 4194304,
  },
  cognito: {
    REGION: "us-east-2",
    USER_POOL_ID: "us-east-2_LOYzLy1zt",
    APP_CLIENT_ID: "1j4fbvhn7gqhsutobj5peqr8se",
    IDENTITY_POOL_ID: "us-east-2:6c088227-436a-4e08-a100-392e33b1b164",
  },
  sessionEdge: {
    enabled: process.env.REACT_APP_VC_SESSION_EDGE_ENABLED === "true",
    cookieName: "vc_last_activity",
    cookieDomain:
      process.env.NODE_ENV === "production" ? ".vicuscapital.com" : "",
    heartbeatPath: "/_/heartbeat",
    heartbeatThrottleMs: 60 * 1000,
  },
};
export default config;
